import { ConfigureGroupMenuCombinedProps } from './types';

const usePresenter = (props: ConfigureGroupMenuCombinedProps): ConfigureGroupMenuCombinedProps => {
  return props;
};

export default usePresenter;
